import { ExamCenterProctorType } from '@exam-center/graphql';

export const DOWNLOADABLE_FILE_EXTENSIONS = ['pdf'];
export const VIEWABLE_FILE_EXTENSIONS = ['jpg', 'jpeg', 'png'];

export const PROCTOR_TYPE_TEXTS: Record<ExamCenterProctorType, string> = {
  [ExamCenterProctorType.Proctor_1]: 'ผู้คุมสอบประเภทที่ 1',
  [ExamCenterProctorType.Proctor_2]: 'ผู้คุมสอบประเภทที่ 2',
  [ExamCenterProctorType.Proctor_3]: 'ผู้คุมสอบประเภทที่ 3',
};
